export default "__VITE_ASSET__57dfdaa9__"